import React, { useEffect, useState } from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import FieldTextAreaAutoSize from '../fields/fieldTextAreaAutoSize';
import { LabelAnswer } from './labelAnswer';
import { typesIcon } from '../../../pages/surveys/steps/modalQuestion';

type Props = {
    title?: string;
    name: any;
    answerQuestion?: any;
    onChange: (value: any) => void;
    idQuestion?: string;
    questionType?: string;
    questionIcon?: string;
    whyQuestion?: boolean;
};

const FieldLinealLabelAnswer = ({
    title,
    name,
    answerQuestion,
    onChange,
    idQuestion,
    questionType,
    questionIcon,
    whyQuestion,
}: Props) => {
    const [value, setValue] = React.useState('');
    const [error, setError] = React.useState(false);
    const [helperText, setHelperText] = React.useState('');
    const [why, setWhy] = useState('');
    const [touched, setTouched] = useState(false);

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue((event.target as HTMLInputElement).value);
        setHelperText(' ');
        setError(false);
        setTouched(true);
    };

    const getIcon = () => {
        return typesIcon.find((t) => t.id === questionIcon) || typesIcon[0];
    };

    useEffect(() => {
        if (value.length === 0 && touched) {
            setHelperText('La respuesta es obligatoria');
            setError(true);
        } else setError(false);

        const dataValues = {
            idQuestion,
            [name]: value,
            type: questionType,
            why: why,
            error: error || !touched,
        };
        onChange(dataValues);
    }, [value, touched]);

    return (
        <>
            <Grid item xs={12} key={idQuestion}>
                <LabelAnswer text={title} />
                <br />
                <FormControl error={error} fullWidth>
                    <Grid
                        display="flex"
                        justifyContent="center"
                        overflow="hidden"
                    >
                        <RadioGroup
                            row
                            onChange={handleRadioChange}
                            sx={{
                                border: error
                                    ? '1px solid #d32f2f'
                                    : '1px solid #E0E0E0',
                                borderRadius: '4px',
                                width: '80%',
                                '.MuiFormHelperText-root': {
                                    textAlign: 'center',
                                },
                            }}
                        >
                            <Grid
                                minWidth="100%"
                                display="inline-block"
                                overflow="overlay"
                            >
                                <Grid display="flex">
                                    {answerQuestion.map((answer: any) => (
                                        <Grid
                                            key={answer.id}
                                            display="block"
                                            style={{
                                                width: `${
                                                    100 /
                                                    (answerQuestion.length || 1)
                                                }%`,
                                                minWidth: '50px',
                                            }}
                                        >
                                            <FormControlLabel
                                                value={answer.id}
                                                control={
                                                    <Radio
                                                        icon={getIcon().icon}
                                                        checkedIcon={
                                                            getIcon().icon2
                                                        }
                                                    />
                                                }
                                                label={answer.label}
                                                labelPlacement="top"
                                                sx={{
                                                    backgroundColor:
                                                        '#D1E2FF8C',
                                                    margin: 0,
                                                    padding: 0,
                                                    justifyContent: 'center',
                                                    width: '100%',
                                                }}
                                                slotProps={{
                                                    typography: {
                                                        fontFamily:
                                                            'Lucida Sans',
                                                        textAlign: 'center',
                                                        fontSize: '15px',
                                                        color: '#4b4b4b',
                                                        bgcolor: '#FFF',
                                                        width: '100%',
                                                    },
                                                }}
                                            />
                                            {answer.description}
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        </RadioGroup>
                    </Grid>
                    <FormHelperText sx={{ textAlign: 'center' }}>
                        {helperText}
                    </FormHelperText>
                </FormControl>
            </Grid>
            {whyQuestion && value && (
                <Grid item xs={12}>
                    <LabelAnswer text="¿Por qué?" isRequired={false} />
                    <br />
                    <FieldTextAreaAutoSize
                        name="why"
                        placeholder="Dejanos aquí las razones de porque"
                        required={false}
                        onChange={(e: any) => setWhy(e.target.value)}
                    />
                </Grid>
            )}
        </>
    );
};

export default FieldLinealLabelAnswer;
